import { useEffect } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import { MoretonBayBillingInitializer } from '@ctct/application-layer';

import { ConfirmationPage } from './ConfirmationPage';
import { MoretonBayBillingPage } from './MoretonBayBillingPage';

import './moreton-bay-billing-page.scss';

const initializer = new MoretonBayBillingInitializer();

const externalHooks = {
  useReturnUrl: () => null,
  useReturnLabel: () => null,
  useIsXeroAddonSelected: () => false,
};

export const MoretonBayPage = () => {
  const { path } = useRouteMatch();

  useEffect(() => {
    initializer.listeners.on();

    return () => {
      initializer.listeners.off();
    };
  }, []);

  return (
    <Switch>
      <Route exact path={`${path}/checkout`}>
        <MoretonBayBillingPage initializer={initializer} />
      </Route>
      <Route exact path={`${path}/confirmation`}>
        <ConfirmationPage initializer={initializer} externalHooks={externalHooks} />
      </Route>
    </Switch>
  );
};
